import { combineReducers } from "@reduxjs/toolkit";
import customerSlice from "./slices/customerSlice";
import customerXMemberClubSlice from "./slices/customerXMemberClubSlice";
import customerFiscalTypeSlice from "./slices/customerFiscalTypeSlice";
import memberClubSlice from "./slices/memberClubSlice";
import customerGroupSlice from "./slices/customerGroupSlice";
import customerXGroupSlice from "./slices/customerXGroupSlice";
import customerXBusPostingGroupSlice from "./slices/customerXBusPostingGroupSlice";
import postingGroupSlice from "./slices/customerPostingGroupSlice";
import customerXPostingGroupSlice from "./slices/customerXPostingGroupSlice";
import customerXPaymentTermSlice from "./slices/customerXPaymentTermSlice";
import memberClubSchemeSlice from "./slices/memberClubSchemeSlice";
import memberClubCardSpoolSlice from "./slices/memberClubCardSpoolSlice";
import customerXSaleSlice from "./slices/customerXSaleSlice";
import pointAccountSlice from "./slices/pointAccountSlice";

export default combineReducers({
  customer: customerSlice,
  memberClub: memberClubSlice,
  customerXMemberClub: customerXMemberClubSlice,
  customerFiscalTypes: customerFiscalTypeSlice,
  customerGroup: customerGroupSlice,
  customerXGroup: customerXGroupSlice,
  customerXBusPostingGroup: customerXBusPostingGroupSlice,
  customerPostingGroup: postingGroupSlice,
  customerXPostingGroup: customerXPostingGroupSlice,
  customerXPaymentTerm: customerXPaymentTermSlice,
  memberClubScheme: memberClubSchemeSlice,
  memberClubCardSpool: memberClubCardSpoolSlice,
  customerXSale: customerXSaleSlice,
  pointAccount: pointAccountSlice
});
